import { CountryType, CreateCountryType, UpdateCountryType } from "types/CountryType";
import { FetchError } from "util/exceptions";
import { API_URL } from "./common";

export const getCountries = (token: string): Promise<CountryType[]> => {
    return fetch(`${API_URL}/v1/ecommerce/countries`, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to fetch countries', response.status);
        }
        return response.json();
    });
};

export const createCountry = (token: string, body: CreateCountryType): Promise<CountryType> => {
    return fetch(`${API_URL}/v1/ecommerce/countries`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to create country', response.status);
        }
        return response.json();
    });
};

export const updateCountry = (token: string, countryId: number, body: UpdateCountryType): Promise<CountryType> => {
    return fetch(`${API_URL}/v1/ecommerce/countries/${countryId}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to update country', response.status);
        }
        return response.json();
    });
};

export const deleteCountry = (token: string, countryId: number): Promise<void> => {
    return fetch(`${API_URL}/v1/ecommerce/countries/${countryId}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
    }).then(response => {
        if (!response.ok) {
            throw new FetchError('Failed to delete country', response.status);
        }
    });
};
